import { MantineColor } from '@mantine/core';

export function toMantineCssVar(color: MantineColor): string {
  return `var(--mantine-color-${String(color).replace('.', '-')})`;
}
